import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table, Button, Modal, Form } from "react-bootstrap";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Promotions = () => {
    const [promotions, setPromotions] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState('add'); // 'add' or 'edit'
    const [formData, setFormData] = useState({ image: null, id: null });
    const [imagePath, setImagePath] = useState('');
    // Fetch promotion data from the API 
    useEffect(() => {
        fetchPromotions();
    }, []);

    const fetchPromotions = () => {
        axios.get("https://apisbtc.gorillafishingroom.com/api/get-promotions")
            .then(response => {
                if (response.data && Array.isArray(response.data.promotions)) {
                    setPromotions(response.data.promotions);
                    setImagePath(response.data.imagePath);
                } else {
                    setPromotions([]);
                }
            })
            .catch(error => {
                console.error("Error fetching promotions:", error);
                toast.error("Failed to fetch promotions.");
            });
    };

    // Handle file input change
    const handleFileChange = (e) => {
        setFormData({ ...formData, image: e.target.files[0] });
    };

    // Handle modal open
    const handleOpenModal = (type, promotion = null) => {
        setModalType(type);
        if (type === 'edit' && promotion) {
            setFormData({ image: null, id: promotion.id });
        } else {
            setFormData({ image: null, id: null });
        }
        setShowModal(true);
    };

    // Handle modal close
    const handleCloseModal = () => {
        setShowModal(false);
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        const formDataObj = new FormData();
        if (formData.image) {
            formDataObj.append('image', formData.image);
        }

        if (modalType === 'add') {
            axios.post("https://apisbtc.gorillafishingroom.com/api/store-promotions", formDataObj)
                .then(() => {
                    toast.success("Promotion added successfully!");
                    fetchPromotions(); // Refresh data
                    handleCloseModal();
                })
                .catch(error => {
                    console.error("Error adding promotion:", error);
                    toast.error("Failed to add promotion.");
                });
        } else if (modalType === 'edit') {
            axios.put(`https://apisbtc.gorillafishingroom.com/api/update-promotions/${formData.id}`, formDataObj)
                .then(() => {
                    toast.success("Promotion updated successfully!");
                    fetchPromotions(); // Refresh data
                    handleCloseModal();
                })
                .catch(error => {
                    console.error("Error updating promotion:", error);
                    toast.error("Failed to update promotion.");
                });
        }
    };

    // Handle delete promotion
    const handleDelete = (id) => {
        axios.delete(`https://apisbtc.gorillafishingroom.com/api/deletepromotions/${id}`)
            .then(() => {
                setPromotions(promotions.filter(promotion => promotion.id !== id));
                toast.success("Promotion deleted successfully!");
            })
            .catch(error => {
                console.error("Error deleting promotion:", error);
                toast.error("Failed to delete promotion.");
            });
    };

    return (
        <>
            <div className="container">
                <div className="d-flex justify-content-between my-3">
                    <h2>Promotions</h2>
                    <Button onClick={() => handleOpenModal('add')} variant="primary" className="mb-3 btn-primary">Add Promotion</Button>
                </div>

                {promotions.length > 0 ? (
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Image</th>
                                <th>Created At</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {promotions.map((promotion, index) => (
                                <tr key={promotion.id}>
                                    <td>{index + 1}</td>
                                    <td>
                                        <img src={`${imagePath}/${promotion.image}`} alt={`Promotion ${promotion.id}`} style={{ width: '100px' }} />
                                    </td>
                                    <td>{new Date(promotion.created_at).toLocaleDateString()}</td>
                                    <td>
                                        <Button variant="warning" onClick={() => handleOpenModal('edit', promotion)}>Edit</Button>{' '}
                                        <Button variant="danger" onClick={() => handleDelete(promotion.id)}>Delete</Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                ) : (
                    <p>No promotions available.</p>
                )}
            </div>

            {/* Modal for Add/Edit Promotion */}
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalType === 'add' ? 'Add Promotion' : 'Edit Promotion'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="formImage" className="mt-3">
                            <Form.Label>Image</Form.Label>
                            <Form.Control
                                type="file"
                                name="image"
                                onChange={handleFileChange}
                                accept="image/*"
                                required={modalType === 'add'}
                            />
                        </Form.Group>
                        <Button variant="primary" type="submit" className="mt-3">
                            {modalType === 'add' ? 'Add Promotion' : 'Update Promotion'}
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>

            {/* Toast container */}
            <ToastContainer />
        </>
    );
};

export default Promotions;
